import { createSlice } from "@reduxjs/toolkit";
export interface accent {
  color: {
    h: number;
    s: number;
    l: number;
  };
  variants: {
    light: string[];
    dark: string[];
  };
}
const intialState: accent[] | [] = [];
const accentsSlice = createSlice({
  name: "accents",
  initialState: intialState,
  reducers: {
    addAccent: (state, action) => {
      state.push(action.payload);
    },
  },
});
export const { addAccent } = accentsSlice.actions;
export default accentsSlice.reducer;
